export default {
  setUser(state, { user }) {
    state.token = user.token;
    // Read back what actions.js's Login just wrote to localStorage (the `user`
    // param here is actually the whole axios response, not response.data.data —
    // pre-existing shape, harmless since localStorage is the real source of truth).
    state.isMaster = localStorage.getItem("is_master") === "1";
  },
  logout(state) {
    state.token = null;
    state.user  = null;
    state.isMaster = false;
    localStorage.removeItem("token");
    localStorage.removeItem("is_master");
  },
  setTheme(state, theme) {
    state.theme = theme;
    localStorage.setItem("portal_theme", theme);
  },
};
